import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = ["onClick", "onMousemove"]
const _hoisted_4 = { class: "list-content" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]

import { ref, onMounted, watch, nextTick } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex'
import { pathTable, pageRoute } from '@/config'
import { asynchronousRetrieval } from '@/utils'

export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderView',
  props: {
  changePath: {
    default: null,
    type: Function
  },
  hideTitle: {
    default: false,
    type: Boolean
  }
},
  setup(__props) {

const loadUrl: any = ref({})

const store = useStore()
const router = useRouter()

const props = __props
const pageTitle: any = ref([])
const selectIndex = ref(0)
const hoverKey = ref('')
const isBlankBg = ref(false)
let timer: any = null;
const childPages: any = ref({
  service: [
    {
      name: '数智产品',
      url: '/product_service',
      title: ['产品服务', '数智产品'],
      index: 1
    },
    {
      name: '渠道拓展',
      url: '/channel_expansion',
      title: ['产品服务', '渠道拓展'],
      index: 1
    }
  ],
  programme: [
    {
      name: '文娱解决方案',
      url: '/solution',
      title: ['解决方案', '文娱解决方案'],
      listIndex: '0',
      index: 2
    },
    {
      name: '工业解决方案',
      url: '/solution',
      title: ['解决方案', '工业解决方案'],
      listIndex: '1',
      index: 2
    },
    {
      name: '教育解决方案',
      url: '/solution',
      title: ['解决方案', '教育解决方案'],
      listIndex: '2',
      index: 2
    },
    {
      name: '医疗解决方案',
      url: '/solution',
      title: ['解决方案', '医疗解决方案'],
      listIndex: '3',
      index: 2
    },
    {
      name: '军警部队解决方案',
      url: '/solution',
      title: ['解决方案', '军警部队解决方案'],
      listIndex: '4',
      index: 2
    }
  ],
  about_as: [
    {
      name: '公司介绍',
      url: '/about_us_view',
      title: ['关于我们', '公司介绍'],
      index: 5
    },
    {
      name: '新闻动态',
      url: '/about_us',
      title: ['关于我们', '新闻动态'],
      index: 5
    },
    {
      name: '加入我们',
      url: '/about_detail',
      title: ['关于我们', '加入我们'],
      index: 5
    }
  ]
})
const titleList = [
  {
    name: '首页',
    path: '/'
  },
  {
    name: '产品服务',
    path: '',
    hasChild: true,
    key: 'service',

  },
  {
    name: '解决方案',
    path: '',
    hasChild: true,
    key: 'programme'
  },
  {
    name: '成功案例',
    path: '/success_cases'
  },
  {
    name: '合作生态',
    path: '/collaboratives'
  },
  {
    name: '关于我们',
    path: '',
    hasChild: true,
    key: 'about_as'
  }
]
const hoverTitleIndex = ref(-1)

const changeUrlEvent = (data: any, index: number, listIndex: string) => {
  store.state.pageTitle = [...data.title]
  store.state.titleIndex = index;
  if (listIndex) {
    router.push(`${data.url}?type=${listIndex}&pathName=${data.title[0]},${data.title[1]}`)
    store.state.programmeIndex = listIndex
  } else {
    router.push(`${data.url}?pathName=${data.title[0]},${data.title[1]}`);
  }
}

const mouseMoveTitle = () => {
  if (timer) {
    clearTimeout(timer)
    timer = null;
  }
}

const changeTitle = (title: any) => {
  // 检查当前是否在详情页（案例详情或新闻详情）
  const currentRoute = router.currentRoute.value;
  const isDetailPage = ['case_detail', 'news_detail', 'job_detail'].includes(currentRoute.name || '');
  
  // 如果是从详情页点击面包屑返回，设置标记保持滚动位置
  if (isDetailPage) {
    window.sessionStorage.setItem('keepScrollPosition', 'true');
  }

  if (store.state.pageTitle[0] == '数智产品') {
    if (title != '数智产品') {
      const activeIndex = store.state.pageTitle.findIndex((e: any) => e == title)
      if (activeIndex == 1) {
        window.localStorage.setItem('product-category', title)
      } else if (activeIndex == 2) {
        window.localStorage.setItem('product-category', store.state.pageTitle[1])
        window.localStorage.setItem('brand', title)
      }
    }

    router.push(pageRoute['数智产品'])
    store.state.pageTitle = ['产品服务', '数智产品']
    return
  }

  if (title.includes('解决方案')) {
    if (title == '解决方案' && store.state.pageTitle.length <= 2) return
    router.push(pageRoute[title])
    if (title == '解决方案') {
      store.state.pageTitle = ['解决方案', '文娱解决方案']
    } else {
      store.state.pageTitle = ['解决方案', title]
    }
    return
  }

  if (['关于我们', '加入我们', '新闻动态'].includes(title)) {
    router.push(pageRoute[title])
    if (title != '关于我们') {
      store.state.pageTitle = ['关于我们', title]
    } else {
      store.state.pageTitle = ['关于我们', '公司介绍']
    }
    return
  }

  if (pageRoute[title]) {
    router.push(pageRoute[title])
    store.state.pageTitle = []
  }
}

const mouseLeaveTitle = () => {
  clearTimeout(timer)
  timer = setTimeout(() => {
    hoverKey.value = ''
    hoverTitleIndex.value = -1;
  }, 500)
}

const handleMouseMove = (key: string, index: number) => {
  if (hoverKey.value != key) {
    hoverKey.value = key || ''
    clearTimeout(timer)
    timer = null;
  }
  hoverTitleIndex.value = index;
}

const handleMouseLeave = () => {
  clearTimeout(timer)
  timer = setTimeout(() => {
    hoverKey.value = ''
    hoverTitleIndex.value = -1;
  }, 500)
}

const selectModel = (index: number, path: string) => {
  if (path) {
    store.state.titleIndex = index;
    props.changePath(path);
    router.push(path)
    store.state.pageTitle = []
  }
}

onMounted(async () => {
  const path: any = JSON.parse(window.sessionStorage.getItem('path') || '{}');
  store.state.titleIndex = pathTable[path.name] || 0;
  if (path.query?.pathName) {
    const routeList = path.query?.pathName.split(',')
    store.state.pageTitle = [...routeList]
  }
})

watch(store.state, (newState) => {
  if (newState.titleIndex != selectIndex.value) {
    selectIndex.value = newState.titleIndex
  }
  pageTitle.value = newState.pageTitle
  setTimeout(() => {
    const hasBanner = document.querySelector('.banner')
    isBlankBg.value = !hasBanner
    if (store.state.titleIndex == 0) {
      isBlankBg.value = false
    }
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("img", {
        class: "logo",
        src: _imports_0,
        onClick: _cache[0] || (_cache[0] = ($event: any) => {_unref(router).push('/'); _unref(store).state.titleIndex = 0;})
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(titleList, (item, index) => {
        return _createElementVNode("div", {
          key: index,
          class: _normalizeClass(((selectIndex.value == index ? 'active' : '') + (hoverTitleIndex.value == index ? ' hoverActive' : '')) + (item.hasChild ? ' has-child' : '')),
          style: _normalizeStyle({ paddingRight: item.hasChild ? '22rem' : '10rem' }),
          onClick: ($event: any) => (selectModel(index, item.path)),
          onMousemove: _withModifiers(($event: any) => (handleMouseMove(item.key || '', index)), ["stop"]),
          onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (handleMouseLeave()))
        }, _toDisplayString(item.name), 47, _hoisted_3)
      }), 64))
    ]),
    (!__props.hideTitle && pageTitle.value.length)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["page-list", isBlankBg.value ? 'blank-bg' : ''])
        }, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageTitle.value, (item, index) => {
              return (_openBlock(), _createElementBlock("span", {
                onClick: ($event: any) => (changeTitle(item)),
                key: index
              }, _toDisplayString(item), 9, _hoisted_5))
            }), 128))
          ])
        ], 2))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(["title-list", isBlankBg.value ? 'blank-bg' : '']),
      onMousemove: mouseMoveTitle,
      onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (mouseLeaveTitle()))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(hoverKey.value)
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(childPages.value[hoverKey.value], (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            onClick: ($event: any) => (changeUrlEvent(item, item.index, item.listIndex))
          }, _toDisplayString(item.name), 9, _hoisted_6))
        }), 128))
      ], 2)
    ], 34), [
      [_vShow, hoverKey.value]
    ])
  ]))
}
}

})